
// import { toast } from "react-toastify";
import swal from "sweetalert";


import axiosClient from "./Globalapi";
export const showAlert = (icon, title, text) => {
  swal({
    title,
    text,
    icon, // "success" | "error" | "warning" | "info"
    timer: 2500,
    buttons: false,
  });
};

// src/global/Globalfunction.js

// export const decodeId = (encodedId) => {
//   try {
//     // Decode Base64 string to original value
//     return atob(encodedId);
//   } catch (error) {
//     console.error("Invalid encoded ID:", error);
//     return null;
//   }
// };
// src/global/Globalfunction.js

// ✅ Encode ID
export const encodeId = (id) => {
  try {
    return btoa(id.toString());
  } catch (error) {
    console.error("Error encoding ID:", error);
    return null;
  }
};

// ✅ Decode ID
export const decodeId = (encodedId) => {
  try {
    return atob(encodedId);
  } catch (error) {
    console.error("Error decoding ID:", error);
    return null;
  }
};
//  export const detectUrlType = (url) => {
//   if (url.includes("/product/")) return "product";
//   if (url.includes("/shopping")) return "shopping";
//   return null;
// };

//   export const extractProductId = (url) => {
//   try {
//     const parts = url.split("/");
//     const last = parts.pop();      // OA==
//     return atob(last);             // decode → "8"
//   } catch {
//     return null;
//   }
// };
// export const extractIdFromShopping = (url) => {
//   try {
//     const params = new URL(url).searchParams;
//     const encoded = params.get("product");  // Nw==
//     return atob(encoded); // 7
//   } catch {
//     return null;
//   }
// };
export const detectUrlType = (url) => {
  const pathname = new URL(url).pathname;

  if (pathname.startsWith("/product/")) return "product";
  if (pathname.startsWith("/shopping")) return "shopping";

  return null;
};

export const extractProductId = (url) => {
  try {
    const pathname = new URL(url).pathname;  // "/product/OA=="
    const encoded = pathname.split("/").pop(); 
    return atob(encoded);   // decode -> 8
  } catch {
    return null;
  }
};

export const extractIdFromShopping = (url) => {
  try {
    const params = new URL(url).searchParams;
    const encoded = params.get("product");
    return encoded ? atob(encoded) : null;
  } catch {
    return null;
  }
};

// export const storeEncodedLead = async (c) => {
//   try {
//     const userId = localStorage.getItem("usertypeid");

//     const urlType = detectUrlType(c.target_url);

//     let finalProductId = null;
//     let finalCategoryId = null;

//     if (urlType === "product") {
//       finalProductId = extractProductId(c.target_url);
//     }

//     if (urlType === "shopping") {
//       finalCategoryId = extractIdFromShopping(c.target_url);
//     }

//     const payload = {
//        user_id: btoa(String(userId)), 
//       product_id: finalProductId ? btoa(String(finalProductId)) : null,
//       category_id: finalCategoryId ? btoa(String(finalCategoryId)) : null,
//       campaign_id: btoa(String(c.campaign_id)),
//       // affiliate_user_id: btoa(String(c.affiliate_user_id)),
//       affiliated_campaign_id: btoa(String(c.affiliated_campaign_id)),
//       from: urlType,           // 🔥 IMPORTANT FIX
//     };

//     await fetch("http://localhost:5000/api/store-lead", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     });

//     console.log("Lead stored successfully");
//   } catch (error) {
//     console.error("Error storing lead:", error);
//   }
// };
///////////////////////////////////////////////////////////////
// export const storeEncodedLead = async () => {
//   try {
//     const userId = localStorage.getItem("usertypeid");

//     const currentUrl = window.location.href; // ⭐ GET URL FROM BROWSER

//     const urlType = detectUrlType(currentUrl);

//     let finalProductId = null;
//     let finalCategoryId = null;

//     if (urlType === "product") {
//       finalProductId = extractProductId(currentUrl);
//     }

//     if (urlType === "shopping") {
//       finalCategoryId = extractIdFromShopping(currentUrl);
//     }

//     const params = new URL(currentUrl).searchParams;

//     const payload = {
//       user_id: userId ? btoa(userId) : null,

//       product_id: finalProductId ? btoa(String(finalProductId)) : null,
//       category_id: finalCategoryId ? btoa(String(finalCategoryId)) : null,

//       campaign_id: params.get("campaign_id") || null,
//       affiliate_user_id: params.get("affiliate_user_id") || null,
//       affiliated_campaign_id: params.get("affiliated_campaign_id") || null,

//       from: urlType,
//     };

//     await fetch("http://localhost:5000/api/store-lead", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     });

//     console.log("Lead stored successfully from window URL");
//   } catch (error) {
//     console.error("Error storing lead:", error);
//   }
// };
export const storeEncodedLead = async (url) => {
  try {
    const userId = localStorage.getItem("usertypeid");

    const finalUrl = url || window.location.href;  

    const urlType = detectUrlType(finalUrl);

    let finalProductId = null;
    let finalCategoryId = null;

    if (urlType === "product") {
      finalProductId = extractProductId(finalUrl);
    }

    if (urlType === "shopping") {
      finalCategoryId = extractIdFromShopping(finalUrl);
    }

    const params = new URL(finalUrl).searchParams;

    const payload = {
      user_id: btoa(String(userId)),
      product_id: finalProductId ? btoa(finalProductId) : null,
      category_id: finalCategoryId ? btoa(finalCategoryId) : null,
      campaign_id: params.get("campaign_id"),
      affiliate_user_id: params.get("affiliate_user_id"),
      affiliated_campaign_id: params.get("affiliated_campaign_id"),
      from: urlType,
    };

    await fetch("http://localhost:5000/api/store-lead", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    console.log("Lead stored successfully");
  } catch (error) {
    console.error("Error storing lead:", error);
  }
};

export const postData = async (url, data) => {
  try {
    return await axiosClient.post(url, data);
  } catch (error) {
    throw error; // ✅ MUST THROW
  }
};

// ✅ Global API Error Handler
// export const handleApiError = (error, options = {}) => {
//   const {
//     closePopup = false,
//     onClose,
//   } = options;

//   // Axios error with response
//   if (error?.response) {
//     const status = error.response.status;
//     const message = error.response.data?.message;

//     if (status === 403) {
//       toast.error(message || "You cannot access this page");
//     } 
//     else if (status === 401) {
//       toast.error(message || "Invalid user");
//     } 
//     else if (status === 400) {
//       toast.error(message || "Bad request");
//     } 
//     else {
//       toast.error(message || "Something went wrong");
//     }
//   }
//   // Network / unknown error
//   else {
//     toast.error("Network error. Please try again.");
//   }

//   // ✅ Optional popup close handling
//   if (closePopup) {
//     setTimeout(() => {
//       window.google?.accounts?.id?.cancel?.();
//       if (onClose) onClose();
//     }, 300);
//   }
// };
export const handleApiError = (error, options = {}) => {
  const { closePopup = false, onClose } = options;

  if (error?.response) {
    const status = error.response.status;
    const message = error.response.data?.message;

    if (status === 403) {
      showAlert("error", "Access Denied", message || "You cannot access this page");
    } 
    else if (status === 401) {
      showAlert("error", "Unauthorized", message || "Invalid user");
    } 
    else if (status === 400) {
      showAlert("warning", "Bad Request", message || "Bad request");
    } 
    else {
      showAlert("error", "Error", message || "Something went wrong");
    }
  } 
  else {
    showAlert("error", "Network Error", "Please try again later");
  }

  if (closePopup) {
    setTimeout(() => {
      window.google?.accounts?.id?.cancel?.();
      if (onClose) onClose();
    }, 300);
  }
};
